import { Component, OnInit } from "@angular/core";
import { MappingService } from "src/core/services/mapping.service";

@Component({
  selector: "app-mapping",
  templateUrl: "./mapping.component.html",
  styleUrl: "./mapping.component.css",
  standalone: false,
})
export class MappingComponent {
  selectedMainTabIndex: number = 0;

  onMainTabChange(index: string | number): void {
    this.selectedMainTabIndex = +index;
  }
}
